import React from "react";
import CIcon from "@coreui/icons-react";
import {
  cilActionUndo,
  cilBell,
  cilBook,
  cilCalculator,
  cilCalendarCheck,
  cilChartPie,
  cilCursor,
  cilDescription,
  cilDrop,
  cilNotes,
  cilPaperclip,
  cilPencil,
  cilPuzzle,
  cilReportSlash,
  cilSpeedometer,
  cilStar,
} from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react";
import { AUTH_KEY } from "./utils/auth/Authentication";

export const teamComponent = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/dashboard",
    authKey: AUTH_KEY.dashboard,
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    badge: {
      color: "info",
    },
  },
  // {
  //   component: CNavGroup,
  //   name: 'Reports',
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Summary',
  //       to: '/summary',
  //       authKey: AUTH_KEY.summary,
  //       icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Daily Recap',
  //       to: '/daily-recap',
  //       authKey: AUTH_KEY.daily_recap,
  //       icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Transaction List',
  //       to: '/transaction-list',
  //       authKey: AUTH_KEY.transactions,
  //       icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Reprint List',
  //       to: '/reprint-list',
  //       authKey: AUTH_KEY.transactions,
  //       icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Voucher Usage',
  //       to: '/voucher-usage',
  //       authKey: AUTH_KEY.voucher_usage,
  //       icon: <CIcon icon={cilBook} customClassName="nav-icon" />
  //     }
  //   ]
  // },
  {
    component: CNavGroup,
    name: "Operasional",
    items: [
      {
        component: CNavItem,
        name: "Rencana Kerja",
        to: "/work-plans",
        authKey: AUTH_KEY.workPlans,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Kunjungan",
        to: "/visitations",
        authKey: AUTH_KEY.visitations,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Report",
    items: [
      {
        component: CNavItem,
        name: "Analisa Toko",
        to: "/store-analytics",
        authKey: AUTH_KEY.purchase_orders,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Analisa Stock",
        to: "/stock-analytics",
        authKey: AUTH_KEY.purchase_orders,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: "Penerimaan Barang",
      //   to: "/goods-receipts",
      //   authKey: AUTH_KEY.goods_receipts,
      //   icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "Stock Adjustment",
      //   to: "/stock-adjustments",
      //   authKey: AUTH_KEY.stockAdjustments,
      //   icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      // },
    ],
  },
  {
    component: CNavGroup,
    name: "Master Data",
    items: [
      {
        component: CNavItem,
        name: "Kategori Produk",
        to: "/categories",
        authKey: AUTH_KEY.categories,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Produk",
        to: "/products",
        authKey: AUTH_KEY.products,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: 'Suppliers',
      //   to: '/suppliers',
      //   authKey: AUTH_KEY.suppliers,
      //   icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />
      // },
      // {
      //   component: CNavItem,
      //   name: 'Customer',
      //   to: '/customers',
      //   authKey: AUTH_KEY.customers,
      //   icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />
      // },
      {
        component: CNavItem,
        name: "Akun",
        to: "/users",
        authKey: AUTH_KEY.users,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Toko",
        to: "/stores",
        authKey: AUTH_KEY.stores,
        icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
      },
    ],
  },
];

// export const defaultSidebar = [
//   {
//     component: CNavItem,
//     name: "Dashboard",
//     to: "/dashboard",
//     authKey: AUTH_KEY.dashboard,
//     icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
//     badge: {
//       color: "info",
//     },
//   },
//   {
//     component: CNavGroup,
//     name: "Reports",
//     items: [
//       {
//         component: CNavItem,
//         name: "Summary",
//         to: "/summary",
//         authKey: AUTH_KEY.summary,
//         icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Daily Recap",
//         to: "/daily-recap",
//         authKey: AUTH_KEY.daily_recap,
//         icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Transaction List",
//         to: "/transaction-list",
//         authKey: AUTH_KEY.transactions,
//         icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Reprint List",
//         to: "/reprint-list",
//         authKey: AUTH_KEY.transactions,
//         icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Voucher Usage",
//         to: "/voucher-usage",
//         authKey: AUTH_KEY.voucher_usage,
//         icon: <CIcon icon={cilBook} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Reviews",
//         to: "/reviews",
//         authKey: AUTH_KEY.reviews,
//         icon: <CIcon icon={cilBook} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Branch Analytics",
//         to: "/branch-analytics",
//         authKey: AUTH_KEY.branch_analytics,
//         icon: <CIcon icon={cilPaperclip} customClassName="nav-icon" />,
//       },
//     ],
//   },
//   {
//     component: CNavGroup,
//     name: "Merchant",
//     items: [
//       {
//         component: CNavItem,
//         name: "Booths",
//         to: "/booths",
//         authKey: AUTH_KEY.booths,
//         icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Merchants",
//         to: "/merchants",
//         authKey: AUTH_KEY.merchant,
//         icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
//       },
//     ],
//   },
//   {
//     component: CNavGroup,
//     name: "Accounting",
//     items: [
//       {
//         component: CNavItem,
//         name: "Refunds",
//         to: "/refunds",
//         authKey: AUTH_KEY.refunds,
//         icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Cash and Bank",
//         to: "/cab",
//         authKey: AUTH_KEY.cash_and_bank,
//         icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Chart of Accounts",
//         to: "/coa",
//         authKey: AUTH_KEY.account_chart,
//         icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Transactions",
//         to: "/account-transactions",
//         authKey: AUTH_KEY.accounting_transactions,
//         icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
//       },
//     ],
//   },
//   {
//     component: CNavGroup,
//     name: "Utilities",
//     items: [
//       {
//         component: CNavItem,
//         name: "Frames",
//         to: "/frames-table",
//         authKey: AUTH_KEY.frames,
//         icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Frame Assignment",
//         to: "/frames-assignment",
//         authKey: AUTH_KEY.frames_assignment,
//         icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
//       },
//       {
//         component: CNavItem,
//         name: "Role Settings",
//         to: "/roles",
//         authKey: AUTH_KEY.frames,
//         icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
//       },
//     ],
//   },

//   // {
//   //   component: CNavItem,
//   //   name: 'Colors',
//   //   to: '/theme/colors',
//   //   icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
//   // },
//   // {
//   //   component: CNavItem,
//   //   name: 'Typography',
//   //   to: '/theme/typography',
//   //   icon: <CIcon icon={cilPencil} customClassName="nav-icon" />,
//   // },
//   // {
//   //   component: CNavTitle,
//   //   name: 'Components',
//   // },
//   // {
//   //   component: CNavGroup,
//   //   name: 'Base',
//   //   to: '/base',
//   //   icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
//   //   items: [
//   //     {
//   //       component: CNavItem,
//   //       name: 'Accordion',
//   //       to: '/base/accordion',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Breadcrumb',
//   //       to: '/base/breadcrumbs',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Cards',
//   //       to: '/base/cards',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Carousel',
//   //       to: '/base/carousels',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Collapse',
//   //       to: '/base/collapses',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'List group',
//   //       to: '/base/list-groups',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Navs & Tabs',
//   //       to: '/base/navs',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Pagination',
//   //       to: '/base/paginations',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Placeholders',
//   //       to: '/base/placeholders',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Popovers',
//   //       to: '/base/popovers',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Progress',
//   //       to: '/base/progress',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Spinners',
//   //       to: '/base/spinners',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Tables',
//   //       to: '/base/tables',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Tooltips',
//   //       to: '/base/tooltips',
//   //     },
//   //   ],
//   // },
//   // {
//   //   component: CNavGroup,
//   //   name: 'Buttons',
//   //   to: '/buttons',
//   //   icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
//   //   items: [
//   //     {
//   //       component: CNavItem,
//   //       name: 'Buttons',
//   //       to: '/buttons/buttons',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Buttons groups',
//   //       to: '/buttons/button-groups',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Dropdowns',
//   //       to: '/buttons/dropdowns',
//   //     },
//   //   ],
//   // },
//   // {
//   //   component: CNavGroup,
//   //   name: 'Forms',
//   //   icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
//   //   items: [
//   //     {
//   //       component: CNavItem,
//   //       name: 'Form Control',
//   //       to: '/forms/form-control',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Select',
//   //       to: '/forms/select',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Checks & Radios',
//   //       to: '/forms/checks-radios',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Range',
//   //       to: '/forms/range',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Input Group',
//   //       to: '/forms/input-group',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Floating Labels',
//   //       to: '/forms/floating-labels',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Layout',
//   //       to: '/forms/layout',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Validation',
//   //       to: '/forms/validation',
//   //     },
//   //   ],
//   // },
//   // {
//   //   component: CNavItem,
//   //   name: 'Charts',
//   //   to: '/charts',
//   //   icon: <CIcon icon={cilChartPie} customClassName="nav-icon" />,
//   // },
//   // {
//   //   component: CNavGroup,
//   //   name: 'Icons',
//   //   icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
//   //   items: [
//   //     {
//   //       component: CNavItem,
//   //       name: 'CoreUI Free',
//   //       to: '/icons/coreui-icons',
//   //       badge: {
//   //         color: 'success',
//   //         text: 'NEW',
//   //       },
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'CoreUI Flags',
//   //       to: '/icons/flags',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'CoreUI Brands',
//   //       to: '/icons/brands',
//   //     },
//   //   ],
//   // },
//   // {
//   //   component: CNavGroup,
//   //   name: 'Notifications',
//   //   icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
//   //   items: [
//   //     {
//   //       component: CNavItem,
//   //       name: 'Alerts',
//   //       to: '/notifications/alerts',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Badges',
//   //       to: '/notifications/badges',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Modal',
//   //       to: '/notifications/modals',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Toasts',
//   //       to: '/notifications/toasts',
//   //     },
//   //   ],
//   // },
//   // {
//   //   component: CNavItem,
//   //   name: 'Widgets',
//   //   to: '/widgets',
//   //   icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
//   //   badge: {
//   //     color: 'info',
//   //     text: 'NEW',
//   //   },
//   // },
//   // {
//   //   component: CNavTitle,
//   //   name: 'Extras',
//   // },
//   // {
//   //   component: CNavGroup,
//   //   name: 'Pages',
//   //   icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
//   //   items: [
//   //     {
//   //       component: CNavItem,
//   //       name: 'Login',
//   //       to: '/login',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Register',
//   //       to: '/register',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Error 404',
//   //       to: '/404',
//   //     },
//   //     {
//   //       component: CNavItem,
//   //       name: 'Error 500',
//   //       to: '/500',
//   //     },
//   //   ],
//   // },
//   // {
//   //   component: CNavItem,
//   //   name: 'Docs',
//   //   href: 'https://coreui.io/react/docs/templates/installation/',
//   //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
//   // },
// ];
